import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ user, onLogout, collapsed, onToggleCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const canManageUsers = user && (user.role === 'app-manager' || user.role === 'admin');

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-title">
          <span className="sidebar-brand">Stock View</span>
        </div>
        <button
          className="sidebar-toggle"
          onClick={onToggleCollapse}
          title={collapsed ? 'Mở rộng' : 'Thu gọn'}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect width="18" height="18" x="3" y="3" rx="2"></rect>
            <path d="M9 3v18"></path>
          </svg>
        </button>
      </div>

      <nav className="sidebar-nav">
          <button
              className={`sidebar-item ${location.pathname === '/smart-board' ? 'active' : ''}`}
              onClick={() => navigate('/smart-board')}
          >
          <span className="sidebar-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
            </svg>
          </span>
              <span className="sidebar-text">Bảng điện</span>
          </button>
        <button
          className={`sidebar-item ${location.pathname === '/distance-to-ma' ? 'active' : ''}`}
          onClick={() => navigate('/distance-to-ma')}
        >
          <span className="sidebar-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 3v18h18" />
              <path d="M18 17V9" />
              <path d="M13 17V5" />
              <path d="M8 17v-3" />
            </svg>
          </span>
          <span className="sidebar-text">Đường Trung bình</span>
        </button>

        {user && user.role === 'app-manager' && (
          <button
            className={`sidebar-item ${location.pathname === '/buy-signals' ? 'active' : ''}`}
            onClick={() => navigate('/buy-signals')}
          >
            <span className="sidebar-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
            </span>
            <span className="sidebar-text">Tín hiệu mua</span>
          </button>
        )}

        {canManageUsers && (
          <button
            className={`sidebar-item ${location.pathname === '/user-management' ? 'active' : ''}`}
            onClick={() => navigate('/user-management')}
          >
            <span className="sidebar-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </span>
            <span className="sidebar-text">Quản lý tài khoản</span>
          </button>
        )}

      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <span className="user-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="8" r="4" />
              <path d="M20 21a8 8 0 1 0-16 0" />
            </svg>
          </span>
          <span className="user-name">{user?.username}</span>
        </div>
        <button onClick={onLogout} className="logout-button">
          <span className="logout-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16,17 21,12 16,7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
          <span className="sidebar-text">Đăng xuất</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
